import Size from "./Size";
import Point from "./Point";

export default class Rect {

    static get zero() {
        return new Rect(0, 0, 0, 0);
    }

    private readonly point: Point;
    private readonly _size: Size;

    constructor(point: Point, size: Size);

    constructor(x: number, y: number, size: Size);

    constructor(x: number, y: number, width: number, height: number);

    constructor(x: number | Point, y: number | Size, width: number | Size = 0, height: number = 0) {
        if (x instanceof Point) {
            this.point = x;
            this._size = y as Size;
            return;
        }
        this.point = new Point(x, y as number);

        if (width instanceof Size) {
            this._size = width;
        } else {
            this._size = new Size(width as number, height);
        }
    }

    get x(): number {
        return this.point.x;
    }
    get y(): number {
        return this.point.y;
    }

    get left(): number {
        return this.point.x;
    }
    get top(): number {
        return this.point.y;
    }

    get width(): number {
        return this._size.width;
    }

    get height(): number {
        return this._size.height;
    }

    get size(): Size {
        return this._size.clone();
    }
}



// WEBPACK FOOTER //
// ./src/shared/xp/geom/Rect.ts